import { addChildAt } from '@ps/bridge/qc/node'
import { Event, EventBus } from '@ps/utils/event-bus'
import store from '@ps/store'
import qc from 'qc'
import { findByUuid } from '@ps/bridge/qc/node/utils'
import { isEraseBrushImages } from '@ps/bridge/qc/base'

export type AddAtlasActionValue = {
  newValue: {
    node: qc.Node // 新节点
    parent: qc.Node // 新节点要插入的目标节点
    index: number // 插入位置
    realNode?: qc.Node // 互动视频编辑器插入的真实节点
  }
  oldValue: {
    node: qc.Node // 新节点
    activeUuid: string // 新增节点时刻的激活节点
  }
}
export function getAddAtlasAction(value: AddAtlasActionValue) {
  return {
    execute: async ({ newValue }: AddAtlasActionValue) => {
      const { node, parent, index, realNode } = newValue
      const editNode = realNode || node
      // 新增节点的时候在 recordHistory 之前已经增加节点了，所以需要判断节点树上是否有该节点
      if (!findByUuid(node.uuid)) {
        addChildAt({
          node,
          parent,
          index,
        })
      }
      // 游戏界面的layer特殊性，动态添加的图片需要设置其visible为true。开始界面和结束界面添加图片不用
      EventBus.$emit(Event.ADD_GAME_OBJECT, editNode.uuid)
      // 擦除组件跟手图片资源、添加后不选中资源
      if (!isEraseBrushImages(parent)) {
        await store.dispatch('workspace/game/updateActiveNode', {
          node: editNode,
          record: false,
        })
      }
      await store.dispatch('workspace/game/resetNativeSize', {
        node: editNode,
        record: false,
      })
    },
    undo: ({ oldValue }: AddAtlasActionValue) => {
      const { node, activeUuid } = oldValue
      node.removeSelf()
      // 如果undo的时候记录了要激活的节点，则激活该节点
      const activeNode = findByUuid(activeUuid)
      if (activeNode) {
        store.dispatch('workspace/game/updateActiveNode', {
          node: activeNode,
          record: false,
        })
      } else {
        store.dispatch('workspace/game/clearActiveNode', {
          record: false,
        })
      }
    },
    value,
    async: true,
    methodName: 'getAddAtlasAction',
  }
}
